import styled from 'styled-components'
import theme from 'common/style/styleSetup'
import common from 'assets/images/templates/common.png'

export const Wrapper = styled.div`
  width: 100%;
  // padding: 2px;
  position: relative;
 
  .ant-table-wrapper {
    .ant-table-container{
      border: 1px solid var(--Gold-stroke, #FFB800);
    }
    .ant-table-ping-right {
      .ant-table-container {      
        ::after {
          box-shadow: inset -10px 0 8px -8px rgb(0 0 0 / 5%);
        }
      }
    }
    .ant-table-ping-left {
      .ant-table-container {
        ::before {
          box-shadow: inset 10px 0 8px -8px rgb(0 0 0 / 5%);
        }
      }
    }
    .ant-table-cell {
      /* font-family: "NotoSansKR-Regular"; */
      /* font-size: 16px;
      letter-spacing: 0.4px;
      text-align: center;
      color: #525356; */
    }
    .ant-table-thead > tr {
      height: 60px;    
       background-color: #1f1f1f;
      th {
        background:  linear-gradient(180deg, #FEEAC3 0%, #FFE6A6 29.17%, #FFB800 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        // border-left: 1px solid #617686;
        border-top: 1px solid var(--Gold-stroke, #FFB800);
        border-bottom: 1px solid var(--Gold-stroke, #FFB800);
        background-color: #1f1f1f;
        text-align: center;

        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
  
        &:first-child {
          border-radius: 0 !important;
          border-left: 1px solid #617686;
        }
        :nth-child(4) {
          border-left: none;
          // padding: 0 4px 0 4%;
          text-align: left;
        }
        &:last-child {
          border-radius: 0 !important;
          border-right: 1px solid #617686;
        }
        :before {
          display: none;
        }
        .ant-table-selection{
          .ant-checkbox-inner{
            width: 30px;
          height: 30px;
          background-color: #101010;
          border: 1px solid #FFB800;
          }
        }
        .ant-checkbox-inner{
            width: 30px;
          height: 30px;
          background-color: #101010;
          border: 1px solid #FFB800;
          }
          .ant-checkbox-inner::after{
            width: 10px;
          height: 15px;
           background-color: #101010;
          
          }
          @media (max-width: 768px) {
        font-size: 12px !important;
          }
          
      }
      td {
        background: #1f1f1f;
        // border: 1px solid var(--Gold-stroke, #FFB800);
        // border-left: 1px solid #617686;
        border-top: 1px solid var(--Gold-stroke, #FFB800);
        border-bottom: 1px solid var(--Gold-stroke, #FFB800);
      }
    }
    .ant-table-tbody .ant-table-row-selected >.ant-table-cell{
       background: transparent;
    }
    .ant-table-tbody > tr {
      height: 40px;
      background: #0c1320;
      cursor: pointer;
      > td {
        word-break: break-all;
        padding: 0 8px;
        background: #0c1320;
        // border-left: 1px solid #617686;
        border-bottom: none;

        text-align: center;
        color: #FFF;

        font-family: Inter;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        // &:last-child {
        //   border-radius: 0 !important;
        //   border-right: 1px solid #617686;
        // }
        :nth-child(3) {
          width: 0;
          padding: 0;
        }
        :nth-child(4) {
          border-left: none;
          /* padding: 0 4px 0 2px; */
          text-align: left;
        }
        
        .ant-checkbox-inner{
            width: 30px;
          height: 30px;
          background-color: #101010;
          border: 1px solid #FFB800;
          }
          .ant-checkbox-inner::after{
            width: 10px;
          height: 15px;
           background-color: #101010;
          
          }
            @media (max-width: 768px) {
            font-size: 10px !important;
          }
        
      }
      :hover {
        background: #0c1320;
        > td {
          background: #0c1320;
        }
      }
      &.ant-table-expanded-row-level-1 {
        > td {
          padding: 18px 12px;
        }
      }
    }
    .ant-table-tbody > tr:nth-child(odd) td{
      background: #2D2D2D !important;
    }
    .ant-table-tbody > tr:nth-child(even) td{
      background: #1f1f1f !important;
    }
}
    .row-style-1 {
      background-color: #f5f5f5;
    }
  }
  .ant-checkbox-wrapper {
    :hover {
      .ant-checkbox-inner {
        background-color: #617686 !important;
      }
    }
    .ant-checkbox-inner {
      :after {
        // background-color: #617686 !important;
      }
    }
  }
  .ant-pagination {
    margin: 36px 0 0 !important;
    justify-content: center;
    .ant-pagination-item{
     
      a{
            background-color: #101010;
            border: 1px solid #FFB800;
            color: #FFF;
            padding-top: 3px;



        font-family: Inter;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
    .ant-pagination-prev,
    .ant-pagination-next {
      span{
            color: white;
    font-size: 15px;
    font-weight: 700;
      }
      // display: none;
      // background-color: red !important;
    }
  }
  .ant-checkbox-wrapper-disabled{
    display: none
  }
`

export const Title = styled.div`
  width: 100%;
  height: 40px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #1b2b43;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  color: #fff;
  .left {
    font-size: 14px;
    .fa {
      color: #a94442;
      margin-right: 8px;
    }
  }
  .right {
    width: 70px;
    height: 25px;
    border: 1px solid #093d66;
    background: #3c5c81;
    font-size: 12px;
    border-radius: 3px;
    text-align: center;
    padding: 6px 0;
    cursor: pointer;
  }
`
export const TitleLableMoney = styled.span`
  font-family: Inter;
 
  font-style: normal;
  font-weight: 700;
  line-height: normal;
 background: var(--Gold-stroke, linear-gradient(180deg, #FEEAC3 0%, #FFE6A6 29.17%, #FFB800 100%));
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
  
`